// services/adminAuthApiClient.js
import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === "production" 
  ? 'https://backend.successtutorial.org' 
  : 'http://localhost:5000';

const adminAuthApiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true,
});

// Simple interceptors - no refresh logic
adminAuthApiClient.interceptors.request.use(
  (config) => {
    // console.log(`🚀 ${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
  },
  (error) => {
    console.error('❌ Request error:', error);
    return Promise.reject(error);
  }
);

adminAuthApiClient.interceptors.response.use(
  (response) => {
    // console.log(`✅ ${response.config.url} - Status: ${response.status}`);
    return response;
  },
  (error) => {
    console.error('❌ Response error:', {
      url: error.config?.url,
      status: error.response?.status,
    });
    return Promise.reject(error);
  }
);

export { adminAuthApiClient };